import * as moment from 'moment/moment';

export function formatDateAsFromNow(date: string) {
  return moment(date).fromNow();
}

export function formatDateAsDefaults(date: string | moment.Moment, displaySeconds?: boolean, displayFractionalSecond?: boolean) {
  return moment(date).format('YYYY/MM/DD hh:mm' + (displaySeconds ? ':ss' : '') + (displaySeconds && displayFractionalSecond ? '.SS' : ''));
}
